import { FC, useState } from 'react';
import { useIntl } from 'react-intl';

import { Button, ButtonSize } from '@/shared/ui';

import { useApproveTooth } from '@/features/approveTooth';

type ApproveToothButtonProps = {
  toothID: string;
  isApproved: boolean;
  disabled: boolean;
  isToothCard?: boolean;
  size?: ButtonSize;
  className?: string;
  testID?: string;
};

export const ApproveToothButton: FC<ApproveToothButtonProps> = (props) => {
  const {
    className,
    testID,
    toothID,
    isApproved,
    disabled,
    isToothCard,
    size = 'medium',
  } = props;

  const { formatMessage } = useIntl();
  const [approveButtonHovered, setApproveButtonHovered] = useState(false);
  // TODO add reportType to filter necessary images
  const { isApproveToothLoading, toggleApproveTooth } = useApproveTooth(
    toothID,
    isApproved,
    isToothCard,
  );

  const isToothApprovedMessage = isApproved && !approveButtonHovered;
  const isToothDisapproveMessage = isApproved && approveButtonHovered;

  return (
    <Button
      data-testid={testID}
      data-component="approve-tooth-button"
      className={className}
      variant="secondary"
      size={size}
      onMouseMove={() => setApproveButtonHovered(true)}
      onMouseLeave={() => setApproveButtonHovered(false)}
      loading={isApproveToothLoading}
      onClick={toggleApproveTooth}
      disabled={disabled || isApproveToothLoading}
      success={!approveButtonHovered && isApproved}
      danger={approveButtonHovered && isApproved}
    >
      {isToothApprovedMessage &&
        formatMessage({
          id: 'toothCard.approved',
          defaultMessage: 'Approved',
        })}

      {isToothDisapproveMessage &&
        formatMessage({
          id: 'toothCard.disapprove',
          defaultMessage: 'Disapprove',
        })}

      {!isApproved &&
        formatMessage({
          id: 'toothCard.approve',
          defaultMessage: 'Approve',
        })}
    </Button>
  );
};
